import Immutable from 'immutable';
import { TOGGLE_SIDE_MENU, LOGIN, REGISTER, GET_PROFILE, SEND_CONTACT, SEARCH_TAB, CLEAR_SEARCH } from './../actions/globalActions';

const defaultState = Immutable.fromJS({
  sideMenuOpened: false,
  loginErrors: null,
  registerErrors: null,
  profile: null,
  contactErrors: null,
  contactSent: false,
  searchResults: [],
});

const global = (state = defaultState, action) => {
  let newState;

  switch (action.type) {
    case TOGGLE_SIDE_MENU:
      newState = state.set('sideMenuOpened', !state.get('sideMenuOpened'));
      break;
    case GET_PROFILE:
      newState = state.set('profile', action.data);
      break;
    case SEARCH_TAB:
      newState = state.set('searchResults', action.data);
      break;
    case CLEAR_SEARCH:
      newState = state.set('searchResults', []);
      break;
    case LOGIN: 
      if(action.errors !== null)
      {
        newState = state.set('loginErrors', action.errors);
      }
      else
      {
        newState = state.set('loginErrors', null);
      }
      if(action.data !== null && action.data.token !== undefined)
      {
        localStorage.setItem('token', action.data.token);
        let intended = localStorage.getItem('intended');
        if(intended !== null) {
          window.location = intended;
          localStorage.removeItem('intended');
        } else {
          window.location.reload();
        } 
      }
      break;  
    case REGISTER: 
      if(action.errors !== null)
      {
        newState = state.set('registerErrors', action.errors);
      }
      else
      {
        newState = state.set('registerErrors', null);
      }
      if(action.data !== null && action.data.token !== undefined)
      {
        localStorage.setItem('token', action.data.token);
        window.location.reload();
      }
      break;  
    case SEND_CONTACT: 
      if(action.errors !== null)
      {
        newState = state.set('contactErrors', action.errors).set('contactSent', true);
      }
      else
      {
        newState = state.set('contactErrors', null).set('contactSent', true);
      }
      break;

    default:
      newState = state;
  }

  return newState;
};

export default global;



// WEBPACK FOOTER //
// ./src/reducers/global.js